
import { IGlobalState } from "@/store";
import HEADER_MENU from "@/typings/app";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import DocLeftMenu from "@/components/DocLeftMenu.vue";
import { useStore } from "vuex";
import { useAPIGroupMenuData } from "@/hooks/doc";
import { onBeforeRouteUpdate, useRouter } from "vue-router";

export default defineComponent({
  components: {
    DocLeftMenu,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const state = reactive({
      menuList: [
        // 广州招标环境临时屏蔽
        {
          id: "1",
          title: "API接入说明",
          path: "/doc/flow",
          children: [
            {
              id: "",
              title: "",
              path: "",
            },
          ],
        },
        {
          id: "2",
          title: "统一认证接入说明",
          path: "/doc/sso",
          // children: [{
          //   id: "",
          //   title: "",
          //   path: "",
          // }]
        }
      ],
    });
    // 头部当前选中的菜单下标
    const headerMenuIndex = computed({
      get: () => store.state.app.headerMenuIndex,
      set: (val) => {
        store.state.app.headerMenuIndex = val;
      },
    });
    const groupTreeData = computed(() => store.state.doc.groupTree);

    /**
     * 获取API接口分组目录树
     */
    const getGroupMenuData = async () => {
      await useAPIGroupMenuData(store);
    };
    /**
     * 组合分组目录树和文档菜单
     */
    function renderGroupAndDocMenu() {
      state.menuList[0].children = [];
      state.menuList = state.menuList.concat(groupTreeData.value);
      state.menuList.push({
        id: "4",
        title: "附录",
        path: "",
        children: [
          {
            id: "4-1",
            title: "返回码说明",
            path: "/doc/returncode",
          },
        ],
      });
    }
    /**
     * 页面一开始加载
     */
    onMounted(async () => {
      headerMenuIndex.value = HEADER_MENU.API;
      await getGroupMenuData();
      await renderGroupAndDocMenu();
    });
    const leftMenuRef = ref<any>(null);
    onBeforeRouteUpdate((to) => {
      if (to.path === "/documenthome") {
        leftMenuRef.value.changeCurMenu({
          id: state.menuList[0].id,
          name: state.menuList[0].title,
          path: state.menuList[0].path
        });
      }
    });
    return {
      ...toRefs(state),
      leftMenuRef
    };
  }
});
